import { useLanguage } from "@/lib/language";

export const Marquee = () => {
  const { t } = useLanguage();
  const row = (ariaHidden) => (
    <div
      aria-hidden={ariaHidden || undefined}
      className="flex shrink-0 items-center"
    >
      {t.marquee.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-serif italic font-light text-2xl sm:text-3xl text-cream/90 px-6 whitespace-nowrap">
            {item}
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-gold inline-block" />
        </span>
      ))}
    </div>
  );

  return (
    <section
      data-testid="editorial-marquee"
      className="bg-charcoal border-y border-gold/20 py-6 overflow-hidden"
    >
      <div className="flex w-max marquee-track">
        {row(false)}
        {row(true)}
      </div>
    </section>
  );
};

export default Marquee;
